import { HandleAuthTokenRefresh, Timeout } from "src/app/helpers/Index";

export const HandleAuthTokenRefreshTimer = async () => {
	await Timeout(Number(process.env.REACT_APP_SERVER_ACCESSTOKENREFRESHMILLISECONDS));
	await HandleAuthTokenRefresh();
}